import { Dispatch } from "react";
import {
  signInWithEmailAndPassword,
  signOut
} from "firebase/auth";
import { auth } from "../../db/firebase";
import { AuthAction } from "./types";

// 🔥 LOGIN
export const loginUser = async (
  dispatch: Dispatch<AuthAction>,
  email: string,
  password: string
) => {
  try {
    dispatch({ type: "SET_LOADING", payload: true });

    const response = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );

    dispatch({
      type: "SET_USER",
      payload: response.user,
    });

  } catch (error) {
    console.error("Erro no login:", error);
  } finally {
    dispatch({ type: "SET_LOADING", payload: false });
  }
};

// 🔥 LOGOUT
export const logoutUser = async (dispatch: Dispatch<AuthAction>) => {
  await signOut(auth);

  dispatch({
    type: "SET_USER",
    payload: null,
  });
};